import { gql } from "@apollo/client";

export const visualSelectorModelFragment = gql`
    fragment VisualSelectorModel on Model {
        id
        description
        assetPath
        articleNumber
        brand {
            id
            shortName
        }
        modelSpecifications {
            id
            name
        }
        color
        children {
            id
            description
            assetPath
            articleNumber
            children {
                id
            }
        }
    }
`;

export const visualSelectorQuery = gql`
    query VisualSelector($filter: ModelFilter!) {
        models(filter: $filter, limit: 100, sort: { field: description, direction: ASC }) {
            nodes {
                ...VisualSelectorModel
            }
            totalCount
        }
    }
    ${visualSelectorModelFragment}
`;
